import ScreenLayoutIcon from './ScreenLayoutIcon';

export default ScreenLayoutIcon;
export * from './types';
export * from './styles';

export { ScreenLayoutIcon };
